import BarChart from "@app/analytics/MeetingPolicy/BarChart/BarChart";
import getColorFromScore from "@app/analytics/MeetingPolicy/getColorFromScore";
import MeetingPolicyModule from "@app/analytics/MeetingPolicy/MeetingPolicyModule";
import { getBarSeries } from "@app/analytics/MeetingPolicy/meetingPolicyUtils";
import useMeetingPolicy from "@app/analytics/MeetingPolicy/useMeetingPolicy";
import useMeetingPolicyQuery from "@app/analytics/MeetingPolicy/useMeetingPolicyQuery";
import { getMetricMetaById } from "@app/analytics/meetops/metrics";

const SORTED_TIME_OF_DAYS = [
  "hour_bin_08_09",
  "hour_bin_09_10",
  "hour_bin_10_11",
  "hour_bin_11_12",
  "hour_bin_12_13",
  "hour_bin_13_14",
  "hour_bin_14_15",
  "hour_bin_15_16",
  "hour_bin_16_17",
  "hour_bin_17_18",
  "hour_bin_18_19",
];

const getFormattedDimension = (d: string | null) => {
  if (d === null) {
    return "N/A";
  }
  const hour = parseInt(d.split("_")[2]) % 12;
  if (hour === 8) return "8a";
  if (hour === 0) return "12p";
  return `${hour}`;
};

const getFormattedDimensionLabel = (d: string | null) => {
  if (d === null) {
    return "N/A";
  }
  const startHour = parseInt(d.split("_")[2]);
  if (startHour >= 12) {
    return `${startHour % 12 === 0 ? 12 : startHour % 12}pm - ${
      (startHour % 12) + 1
    }pm`;
  }
  return `${startHour}am - ${startHour + 1}${
    startHour + 1 === 12 ? "pm" : "am"
  }`;
};

const DayOfWeekModule = () => {
  const { toggleState, selectedMetric } = useMeetingPolicy();
  const { highest, lowest, meetingCountSeries, metricSeries, readSeries } =
    useMeetingPolicyQuery({ dimension: "hour" });

  const metricMeta = getMetricMetaById(selectedMetric);

  const barMetricsSeries = getBarSeries(
    "vertical",
    "bar",
    SORTED_TIME_OF_DAYS,
    metricSeries ?? [],
    {
      fillColor: (d) => getColorFromScore(d ?? 0),
      name: metricMeta?.displayName ?? "",
      hideLabels: !toggleState.chartLabels,
      formatDimension: getFormattedDimension,
    }
  );

  const textMetricSeries = toggleState.meetingCount
    ? [
        getBarSeries(
          "vertical",
          "text",
          SORTED_TIME_OF_DAYS,
          meetingCountSeries ?? [],
          { name: "Meetings", formatString: (s) => (s ? `[${s}]` : null) }
        ),
      ]
    : [];

  const readMetricSeries = toggleState.readAverage
    ? [
        getBarSeries(
          "vertical",
          "line",
          SORTED_TIME_OF_DAYS,
          readSeries ?? [],
          { name: "Read Avg", formatDimension: getFormattedDimension }
        ),
      ]
    : [];

  return (
    <MeetingPolicyModule
      title="Time of Day"
      highest={getFormattedDimensionLabel(highest) ?? "-"}
      lowest={getFormattedDimensionLabel(lowest) ?? "-"}
    >
      <BarChart
        series={[barMetricsSeries, ...textMetricSeries, ...readMetricSeries]}
        orientation="vertical"
        layout={{
          yAxis: {
            label: metricMeta.displayName,
            numTicks: 6,
          },
        }}
      />
    </MeetingPolicyModule>
  );
};

export default DayOfWeekModule;
